module.exports = __webpack_public_path__ + "media/images/common/dummy_user-37444d24d8a1bc62995b5953801be95c.svg";